__webpack_require__.p = "https://embed.vaya.chat/";